var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.goTopShow),expression:"goTopShow"}],attrs:{"id":"goTop"}},[_c('div',{staticClass:"goTop",on:{"click":_vm.goTop}},[_c('img',{staticClass:"goTopIcon",attrs:{"src":require("@/assets/images/icon_gotop_top.png")}})])])
}
var staticRenderFns = []

export { render, staticRenderFns }